import React, { useState } from "react";
import { Col, Row, DatePicker } from "antd";
import VisitorAnalyticsWidget from "./VisitorAnalyticsWidget/index";
import ChatAnalyticsWidget from "./ChatAnalyticsWidget/index";
import PageViewedAnalyticsWidget from "./PageViewedAnalyticsWidget/index";
import SatisfactionAnalytics from "./SatisfactionAnalytics/index";
import GraphAnalytics from "./GraphAnalytics/index";
import { useSelector } from "react-redux";
import { rangePresets } from "./constants";
import { DashboardContextProvider } from "./contexts/DashboardContextProvider";
import MissedChats from "./MissedChats/index";
import dayjs from "dayjs";
import PropertiesFilter from "../../components/PropertiesFilter";

const { RangePicker } = DatePicker;

const Dashboard = () => {
  const selectedProperties = useSelector(
    (state) => state.properties.selectedProperties
  );

  const [rangeLabel, setRangeLabel] = useState("Last 7 days");
  const [dateRange, setDateRange] = useState([
    dayjs().subtract(7, "day"),
    dayjs(),
  ]);

  const onChangeDateRange = (dates) => {
    if (dates) {
      setDateRange(dates);
    } else {
      console.log("Clear");
    }
  };

  const disabledDate = (current) => {
    return current && current > new Date();
  };

  return (
    <DashboardContextProvider>
      <div className="dashboard_container p-h">
        <Row gutter={[0, 16]} className="flex_between">
          <Col lg={8} md={6} sm={6} xs={24}>
            <h2 className="heading">Dashboard</h2>
          </Col>

          <Col lg={16} md={18} sm={18} xs={24}>
            <Row gutter={[16, 16]}>
              <Col lg={14} md={14} sm={14} xs={24}>
                <PropertiesFilter />
              </Col>
              <Col lg={10} md={10} sm={10} xs={24}>
                <RangePicker
                  disabledDate={disabledDate}
                  onChange={onChangeDateRange}
                  className="full_width"
                  allowClear={false}
                  presets={rangePresets}
                  defaultValue={dateRange}
                  format="MMM, DD, YYYY"
                />
              </Col>
            </Row>
          </Col>
        </Row>
        <Row gutter={[16, 16]} style={{ marginTop: "2rem" }}>
          <Col md={6} sm={12} xs={24}>
            <VisitorAnalyticsWidget
              propertyIds={selectedProperties}
              dateRange={[
                new Date(dateRange[0].toDate()),
                new Date(dateRange[1].toDate()),
              ]}
              rangeLabel={rangeLabel}
            />
          </Col>
          <Col md={6} sm={12} xs={24}>
            <ChatAnalyticsWidget
              propertyIds={selectedProperties}
              dateRange={[
                new Date(dateRange[0].toDate()),
                new Date(dateRange[1].toDate()),
              ]}
              rangeLabel={rangeLabel}
            />
          </Col>
          <Col md={6} sm={12} xs={24} className="page_view_card">
            <PageViewedAnalyticsWidget
              propertyIds={selectedProperties}
              dateRange={[
                new Date(dateRange[0].toDate()),
                new Date(dateRange[1].toDate()),
              ]}
              rangeLabel={rangeLabel}
            />
          </Col>
          <Col md={6} sm={12} xs={24}>
            <MissedChats
              propertyIds={selectedProperties}
              dateRange={[
                new Date(dateRange[0].toDate()),
                new Date(dateRange[1].toDate()),
              ]}
              rangeLabel={rangeLabel}
            />
          </Col>
        </Row>
        <Row gutter={[16, 16]} style={{ marginTop: "2rem" }}>
          <Col xl={10} xs={24}>
            <GraphAnalytics
              propertyIds={selectedProperties}
              dateRange={[
                new Date(dateRange[0].toDate()),
                new Date(dateRange[1].toDate()),
              ]}
            />
          </Col>
          <Col xl={6} xs={24} className="satisfactory_col">
            <SatisfactionAnalytics
              propertyIds={selectedProperties}
              dateRange={[
                new Date(dateRange[0].toDate()),
                new Date(dateRange[1].toDate()),
              ]}
            />
          </Col>
        </Row>
      </div>
    </DashboardContextProvider>
  );
};

export default Dashboard;
